/**
 * Le API esterne di BesteHR: che cosa un sistema esterno può leggere, e con quale chiave ([[K675]]).
 *
 * Nate il 2026-10-19 per Beste APS-MES, che pianifica la produzione e deve sapere chi c'è e
 * quando (richiesta «Beste APS-MES → BesteHR: API richieste», v1 del 15/10). Cosimo: «Va fatto
 * un menu di gestione delle api e delle chiavi con cura assoluta».
 *
 * Questo file è il **catalogo degli ambiti**: un ambito è una porta, e una chiave apre solo le
 * porte che le sono state date. Sta in `shared` perché lo leggono in due — il server, che lo
 * pretende su ogni rotta, e il pannello, che lo mostra a chi crea la chiave — e due elenchi
 * scritti a mano divergono alla prima aggiunta (§116).
 */
export const AMBITI_API = {
    'identita:verifica': {
        nome: 'Verifica delle credenziali',
        descrizione: 'Utente e password di una persona → chi è (id, nome, cognome), oppure il rifiuto. Il ' +
            'servizio non riceve sessioni né gettoni: solo la risposta. I tentativi sbagliati contano ' +
            'per il blocco come quelli dall’app.',
    },
    'dipendenti:lettura': {
        nome: 'Anagrafica dei dipendenti',
        descrizione: 'Id, matricola, nome, cognome, reparto, attivo, assunzione e cessazione, e fino a quando ' +
            'sono pubblicati i turni. Niente codice fiscale, indirizzi, contratti o retribuzioni.',
    },
    'turni:lettura': {
        nome: 'Turni',
        descrizione: 'I turni tipo e i turni pubblicati, giorno per giorno. Le bozze non pubblicate non escono.',
    },
    'assenze:lettura': {
        nome: 'Assenze',
        descrizione: 'Chi non c’è e quando: ferie, permessi e ogni altra assenza, approvate o in attesa. Il ' +
            'motivo non esce mai (può essere un dato sanitario).',
    },
    'calendario:lettura': {
        nome: 'Calendario aziendale',
        descrizione: 'I giorni lavorativi della settimana, le festività nazionali e le chiusure aziendali.',
    },
};
export const ELENCO_AMBITI_API = Object.keys(AMBITI_API);
export function eAmbitoApi(x) {
    return typeof x === 'string' && Object.prototype.hasOwnProperty.call(AMBITI_API, x);
}
/** Le misure dei campi del pannello: una sola volta, per server e Cruscotto. */
export const CHIAVE_API = {
    servizio: { nome: { min: 2, max: 80 }, descrizione: { max: 500 }, referente: { max: 120 } },
    chiave: { etichetta: { min: 2, max: 80 }, indirizzi: { max: 20 } },
    /** Quanti giorni la chiave vecchia resta valida dopo una rotazione, al massimo. */
    sovrapposizioneGiorni: { max: 30 },
};
/**
 * La forma della chiave: `bhr_` + 12 caratteri pubblici + `_` + 43 di segreto (base64url di 32
 * byte). Il prefisso `bhr_` è lì perché chi trova una chiave incollata in un file sappia di che
 * cosa si tratta; la parte pubblica è quella che si legge nel pannello e nei registri.
 */
export const FORMA_CHIAVE_API = /^bhr_([a-z0-9]{12})_([A-Za-z0-9_-]{43})$/;
//# sourceMappingURL=api-esterna.js.map